export enum Prefix {
    Desktop = 'dsk',
    Mobile = 'mob',
    Image = 'img',
}

export const uniqueId = (() => {
    let num = 0;
    return (prefix = ''): string => {
        num += 1;
        return prefix + num;
    };
})();